module.exports = __webpack_public_path__ + "static/Gilroy-Light-bcc98a0e12db17b350e25b8ba5639cf8.woff";